import React from "react";
import "../mycontent.css";
import { Form, Input, Button, Card } from "antd";
import { connect } from "react-redux";
import {
  createContentUnit,
  fetchContentUnit,
  updateContentUnit,
  emptyContentUnit,
} from "../../../../store/actions/selfContentUnitAction";
import { MY_CONTENT_BASE_URL } from "../../../../constants/LookupConst";
import CircularProgress from "../../../../components/CircularProgress";
import { toast } from "react-toastify";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

class SelfDigital extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  formRef = React.createRef();

  async componentDidMount() {
    const {
      match: { params },
      fetchContentUnit,
    } = this.props;
    if (params.id) {
      await fetchContentUnit("digital", params.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // const { selectedContentUnit } = this.props;
    // if (
    //   prevProps.selectedContentUnit &&
    //   prevProps.selectedContentUnit._id !== selectedContentUnit._id
    // ) {
    //   this.setState({
    //     category: selectedContentUnit.category,
    //     mainsubjectname: selectedContentUnit.mainsubjectname,
    //     subsubjectname: selectedContentUnit.subsubjectname,
    //   });
    // }
  }

  async componentWillUnmount() {
    this.props.emptyContentUnit();
  }

  onCategoryChange = (data) => {
    this.setState({ category: data });
  };
  onMainSubjectNameChange = (data) => {
    this.setState({ mainsubjectname: data });
  };
  onSubSubjectNameChange = (data) => {
    this.setState({ subsubjectname: data });
  };

  render() {
    const onFinish = async (values) => {
      const { history } = this.props;
      // const { category, mainsubjectname, subsubjectname } = this.state;
      if (!params.id) {
        await this.props.createContentUnit(
          "digital",
          {
            ...values,
            // category, mainsubjectname, subsubjectname
          },
          (res) => {
            if (res.success) {
              toast.success(res.message);
            } else {
              toast.error(res.message);
            }
          }
        );
      } else {
        await this.props.updateContentUnit(
          "digital",
          {
            ...values,
            // category, mainsubjectname, subsubjectname
          },
          params.id,
          (res) => {
            if (res.success) {
              toast.success(res.message);
            } else {
              toast.error(res.message);
            }
          }
        );
      }
      history.push(`${MY_CONTENT_BASE_URL}?tab=digital`);
    };

    const {
      // lookupDigitalYears,
      // location: { search },
      match: { params },
      selectedContentUnit,
      loading,
      // countries,
      // professors
    } = this.props;
    const data = selectedContentUnit;
    if (!(data && data._id) && params.id) {
      return (
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      );
    }
    return (
      <Card className="gx-card blast-mc" title="Create Digital">
        {!loading ? (
          <Form
            ref={this.formRef}
            {...formItemLayout}
            name="register"
            onFinish={onFinish}
            scrollToFirstError
          >
            <Form.Item
              name="unitname"
              label="Title"
              initialValue={data.unitname}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid title",
                },
                {
                  required: true,
                  message: "Please input title",
                },
              ]}
            >
              <Input placeholder="Please enter a title" value={data.unitname} />
            </Form.Item>
            <Form.Item
              name="author"
              label="Author Name"
              initialValue={data.author}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid author name",
                },
              ]}
            >
              <Input
                placeholder="Please enter a author name"
                value={data.author}
              />
            </Form.Item>
            <Form.Item
              name="url"
              label="URL"
              initialValue={data.url}
              rules={[
                {
                  type: "url",
                  message: "The input is not valid url",
                },
                // {
                //   required: true,
                //   message: "Please input url",
                // },
              ]}
            >
              <Input placeholder="Please enter a url" value={data.url} />
            </Form.Item>
            {/* <InputSelectAdd
              category={"category"}
              placeholder={`Please assign a category`}
              onChange={this.onCategoryChange}
              parenttype={"otherstuff"}
              name={"category"}
              initialValue={this.state.category}
              label={"Category"}
            />
            <InputSelectAdd
              category={"mainsubjectname"}
              placeholder={`Please assign main subject name`}
              onChange={this.onMainSubjectNameChange}
              parenttype={"otherstuff"}
              name={"mainsubjectname"}
              initialValue={this.state.mainsubjectname}
              label={"Main Subject Name"}
            />
            <InputSelectAdd
              category={"subsubjectname"}
              placeholder={`Please assign sub subject name`}
              onChange={this.onSubSubjectNameChange}
              parenttype={"otherstuff"}
              name={"subsubjectname"}
              initialValue={this.state.subsubjectname}
              label={"Sub Subject Name"}
            /> */}
            {/* <Form.Item
            name="startdate"
            label="Start date"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select test date!",
            //   },
            // ]}
            initialValue={moment()}
          >
            <DatePicker
              placeholder="Please enter a start date"
              // value={scheduledAt}
              format="MM/DD/YYYY"
              className="gx-w-100"
              // onChange={this.onDateChange}
            />
          </Form.Item>
          <Form.Item
            name="enddate"
            label="End date"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select test date!",
            //   },
            // ]}
            // initialValue={moment()}
          >
            <DatePicker
              placeholder="Please enter a end date"
              // value={scheduledAt}
              format="MM/DD/YYYY"
              className="gx-w-100"
              // onChange={this.onDateChange}
            />
          </Form.Item> */}
            {/* <Form.Item
              name="additionalinformation"
              label="Additional Information"
              initialValue={data.additionalinformation}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid additionalinformation",
                },
                // {
                //   required: true,
                //   message: "Please input additionalinformation",
                // },
              ]}
            >
              <Input
                placeholder="Please enter a additionalinformation"
                value={data.additionalinformation}
              />
            </Form.Item> */}
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                {!!params.id ? "Update" : "Create"}
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div className="gx-loader-view">
            <CircularProgress />
          </div>
        )}
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedContentUnit: state.selfcontentunits.selectedContentUnit,
  loading: state.selfcontentunits.loading,
});

const mapDispatchToProps = {
  createContentUnit,
  fetchContentUnit,
  updateContentUnit,
  emptyContentUnit,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfDigital);
